import { getConfig } from '~config/getConfig'
import { initSentry } from '~logic/sentry/initSentry'

type TInitOptions = FirstParam<typeof initSentry>

/**
 * Returns Sentry init options for the current app stage.
 *
 * Environments:
 * https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/environments/
 * https://docs.sentry.io/product/sentry-basics/environments/
 */
export const getSentryInitOptions = () => {
  const config = getConfig()

  const SENTRY_DSN = config.sentryDSN
  const APP_STAGE = config.appStage

  const initOptions: TInitOptions = {
    dsn: SENTRY_DSN,
    environment: APP_STAGE,
  }

  return initOptions
}
